<template>
  <div class="surface-input">
    <a-date-picker
        style="display: block;"
        mode="year"
        v-model="stateValue"
        v-bind:placeholder="placeholder"
        v-bind:open="isOpen"
        format="YYYY"
        @openChange="handleOpenChange"
        @panelChange="handlePanelChange"
        @change="onChange"
    ></a-date-picker>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "YearComponent",
  model: {
    prop: 'value',
    event: 'change.value'
  },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      default: '',
    },
  },
  data() {
    return {
      stateValue: this.value,
      isOpen: false,
    };
  },
  watch: {
    value: function value(val) {
      this.stateValue = val;
    }
  },
  mounted() {
  },
  methods: {
    onChange: function onChange(moment, year) {
      this.stateValue = moment;
      this.$emit('change.value', moment);
    },
    handlePanelChange: function (moment) {
      this.stateValue = moment;
      this.isOpen = false;
    },
    handleOpenChange: function (status) {
      this.isOpen = status;
    },
  }
}
</script>

<style scoped>
</style>
